const styles = theme => ({
  fullWidthDiv: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '24px',
    backgroundColor: '#F4F6F8',
    borderRadius: '16px',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      padding: '16px',
    },
  },
  fullWidthDivMid: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',
    backgroundColor: '#F4F6F8',
    padding: '60px 40px',
    borderRadius: '16px',
    marginBottom: theme.spacing(3),
    // add background image on the middle of the div.
    backgroundImage: `url(${'/assets/collection-landing/footer-bg.svg'})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
  img: {
    width: '50%',
    height: 'auto',
    borderRadius: '8px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '50%',
    padding: '60px 40px',
    [theme.breakpoints.down('md')]: {
      padding: '16px',
      width: '100%',
    },
  },

  fullWidthDivWithTwoItem: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  fullWidthDivWithThreeItem: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  independentContent: {
    flex: 1,
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '40px',
    backgroundColor: '#F4F6F8',
    borderRadius: '16px',
    '& img': {
      width: '100%',
      height: 'auto',
      borderRadius: '8px',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  independentContentThreeItem: {
    flex: 1,
    width: '33.33%',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '40px',
    backgroundColor: '#F4F6F8',
    borderRadius: '16px',
    minHeight: '433px',
    height: '100%',
    '& img': {
      width: '100%',
      height: 'auto',
      borderRadius: '8px',
    },
    [theme.breakpoints.down('md')]: {
      height: 'auto',
      width: '100%',
    },
  },
  gradientText: {
    background: 'linear-gradient(to right, #6FB6FE, #015FFB)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundPosition: 'left',
    backgroundSize: '200%',
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
})

export default styles
